import { lazy } from 'react'
import { Outlet } from 'react-router-dom'

import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext.tsx'
import { AvisosCocinaProvider } from '../cocina/contexts/AvisosCocinaProvider.tsx'

const RestGestionApp = lazy(() => import('./view/PedidoGestion.tsx'))
const RestFacturasApp = lazy(() => import('./view/./FacturaGestion'))
const RestPedidoApp = lazy(() => import('./view/pedido/PedidoRegistro'))

export const restauranteRoutesMap = {
  registro: {
    path: '/pedidos/registrar',
    name: 'Registrar Pedido',
    action: 'REGISTRAR_PEDIDO',
  },
  gestion: {
    path: '/pedidos/gestion',
    name: 'Gestión de Pedidos',
    action: 'GESTION_DE_PEDIDOS',
  },
  facturas: {
    path: '/pedidos/facturas',
    name: 'Gestión de Facturas',
    action: 'GESTION_DE_FACTURAS',
  },
}

const pedidosRoutes = [
  {
    path: restauranteRoutesMap.registro.path,
    element: (
      <OperacionesProvider>
        <RestPedidoApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: restauranteRoutesMap.gestion.path,
    element: (
      <OperacionesProvider>
        <RestGestionApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: restauranteRoutesMap.facturas.path,
    element: (
      <OperacionesProvider>
        <RestFacturasApp />{' '}
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]

/**
 * Ruta layout (sin path) que envuelve las vistas de pedidos con los avisos de cocina.
 * Al navegar entre registro, gestión y facturas el provider no se desmonta, así que los avisos
 * y su sondeo continúan sin reiniciarse. AuthGuard sigue validando cada ruta hija (flat()).
 */
const restaurantRoutes = [
  {
    element: (
      <AvisosCocinaProvider>
        <Outlet />
      </AvisosCocinaProvider>
    ),
    children: pedidosRoutes,
  },
]

export default restaurantRoutes
